var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form__group" },
    [
      _c("TreeSelect", {
        ref: "select",
        attrs: {
          options: _vm.items,
          placeholder: "Select...",
          multiple: _vm.treeSelectOptions.multiple,
          searchable: _vm.treeSelectOptions.searchable,
          flat: _vm.treeSelectOptions.flat,
          async: _vm.treeSelectOptions.async,
          autoDeselectAncestors: _vm.treeSelectOptions.autoDeselectAncestors,
          autoDeselectDescendants:
            _vm.treeSelectOptions.autoDeselectDescendants,
          autoSelectAncestors: _vm.treeSelectOptions.autoSelectAncestors,
          autoSelectDescendants: _vm.treeSelectOptions.autoSelectDescendants,
          flattenSearchResults: _vm.treeSelectOptions.flattenSearchResults,
          "auto-load-root-options": _vm.treeSelectOptions.autoLoadRootOptions,
          "flatten-search-results": _vm.treeSelectOptions.flattenSearchResults,
          "open-direction": _vm.treeSelectOptions.openDirection,
          "default-options": _vm.treeSelectOptions.defaultOptions,
          "load-options": _vm.loadOptions,
        },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "form__label" }, [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form__validation",
          attrs: { slot: "validation" },
          slot: "validation",
        },
        [_vm._v(_vm._s(_vm.errors.first(this.name)))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }